import { RootState } from "../rootReducer";
import { AppState } from "./types";

export const getAppState = (store: RootState): AppState => store.app;

export const getRequiresAppUpdate = (store: RootState): boolean =>
  getAppState(store).requiresUpdate;
